export default __webpack_public_path__ + "static/media/AHL Dark.bd90aa0a.svg";